const PriceSeparator = (number) => {
    if (number == null){
        return number;
    }
    return number?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export default PriceSeparator;
